import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';

import { Container, ContainerSVG, ContainerSVGMobile, WrapperExpanded } from './index.styled';
import { setCurrentMap } from './../../../effects/actions'
import { useResize } from '../../../hooks';
import { ContainerInfo } from './container-info';
import { Map } from '../..';

const MapExpandedComponent = React.memo(({ currentMap, currentSite }) => {
  const [activeInfo, setActiveInfo] = React.useState(true);
  const isMobile = useResize().isMobile;
  const mini = (isMobile && activeInfo) ? true : false;

  if (isMobile) return (
    <React.Fragment>
      {activeInfo && <ContainerInfo onClick={() => setActiveInfo(false)} />}
      <ContainerSVGMobile mini={mini}><Map name={currentMap} mini={mini} currentSite={currentSite} /></ContainerSVGMobile>
    </React.Fragment>
  )
  return (
    <Container id="expanded-container" expanded={true}>
      <WrapperExpanded id="expanded-wrapper">
        <ContainerSVG><Map name={currentMap} mini={false} currentSite={currentSite} /></ContainerSVG>
      </WrapperExpanded>
    </Container>
  )
})

MapExpandedComponent.propTypes = {
  str: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  type: PropTypes.string,
}
const mapStateToProps = ({ app }) => {
  const { currentMap, currentSite } = app
  return { currentMap, currentSite }
}
export default connect(mapStateToProps, { setCurrentMap })(React.memo(MapExpandedComponent));

